module.exports = __webpack_public_path__ + "static/media/upload.d878cece.svg";